export default "__VITE_PUBLIC_ASSET__d89829eb__"